import React, { useState } from 'react';
import {
    BrowserRouter as Router, Switch, Route, Link , useHistory
  } from "react-router-dom";
import { SelectDD , ExternalDD } from '../../../../common/dropdowns';

const skillData = [ // Example Datastructure, Value should be unique, label should be set to display text.
    { value: 'example1', label: 'Example1' },
    { value: 'example2', label: 'Example2' },
  ]

const EditSkill1 = ({ toggle }) => {
    const [collapse, setCollapse] = useState(false);
    const togglecollapse = () => setCollapse(!collapse);
    const [selected, setSelected] = useState(skillData[0]);
    return (
        <div >
            <div className="modal-subheader">Add Skill</div>
            <div className="row mg-b-30">
                <div className="col-md-5 mg-r-10">
                <SelectDD data={skillData} onChange={(o) => setSelected(o)} selected={selected} isClearable={false} />
                </div>
                <div className="col-md-5">
                    <button className="btn btn-small btn-default">
                        <i className="fas fa-plus mg-r-5"></i>Add Skill
                        <span className="button-info">3</span>
                    </button>
                </div>
            </div>  
            <div className="v-align mg-b-5">
                <div className="v-align wd-pct-72">
                    <div className="text-dark mg-r-20">Python</div>
                    <div className="text-small-muted mg-r-5">Highest Level:</div>
                    <div className="label label-success-lite">Advanced</div>
                    <div className="text-small-dark mg-r-40">40%</div>
                </div>
                <div className="wd-pct-14">           
                    <button className="btn btn-mini btn-primary">
                        <i className="fas fa-info mg-r-5"></i>Take a Test
                    </button>                
                </div>  
                <div className="wd-pct-14">           
                    <button className="btn btn-mini btn-primary">
                        <i className="fas fa-info mg-r-5"></i>Test History
                    </button>                
                </div> 
            </div>
            <div className="v-align mg-b-15 pd-b-15 b-b-border">
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5">Best Score:</div>
                        <div className="label label-default-lite">Basic</div>
                        <div className="text-small-dark mg-r-5">90%</div>
                    </div>
                </div>
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5">Level Visibile:</div>
                        <div className="label label-warning-lite">Medium</div>
                        <div className="text-small-dark mg-r-5">70%</div>
                    </div>
                </div>
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5"># Tests taken:</div>
                        <div className="text-small-dark mg-r-20">15</div>  
                    </div> 
                </div>         
            </div>
            
            <div className="v-align mg-b-5">
                <div className="v-align wd-pct-72">
                    <div className="text-dark mg-r-20">Reactjs</div>
                    <div className="text-small-muted mg-r-5">Highest Level:</div>
                    <div className="label label-success-lite">Advanced</div>
                    <div className="text-small-dark mg-r-40">40%</div>
                </div>
                <div className="wd-pct-14">           
                    <button className="btn btn-mini btn-primary">
                        <i className="fas fa-info mg-r-5"></i>Take a Test
                    </button>                
                </div> 
                <div className="wd-pct-14">           
                    <button className="btn btn-mini btn-primary">
                        <i className="fas fa-info mg-r-5"></i>Test History
                    </button>                
                </div> 
            </div>
            <div className="v-align mg-b-15 pd-b-15 b-b-border">
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5">Best Score:</div>
                        <div className="label label-default-lite">Basic</div>
                        <div className="text-small-dark mg-r-5">90%</div>
                    </div>
                </div>
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5">Level Visibile:</div>
                        <div className="label label-warning-lite">Medium</div>
                        <div className="text-small-dark mg-r-5">70%</div>
                    </div>
                </div>
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5"># Tests taken:</div>
                        <div className="text-small-dark mg-r-20">15</div>  
                    </div> 
                </div>         
            </div>
            <div className="v-align mg-b-5">
                <div className="v-align wd-pct-72">
                    <div className="text-dark mg-r-20">Html</div>
                    <div className="text-small-muted mg-r-5">Highest Level:</div>
                    <div className="label label-success-lite">Advanced</div>
                    <div className="text-small-dark mg-r-40">40%</div>
                </div>
                <div className="wd-pct-14">           
                    <button className="btn btn-mini btn-primary">
                        <i className="fas fa-info mg-r-5"></i>Take a Test
                    </button>                
                </div>  
                <div className="wd-pct-14">           
                    <button className="btn btn-mini btn-primary">
                        <i className="fas fa-info mg-r-5"></i>Test History
                    </button>                
                </div> 
            </div>
            <div className="v-align mg-b-15 pd-b-15">
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5">Best Score:</div>
                        <div className="label label-default-lite">Basic</div>
                        <div className="text-small-dark mg-r-5">90%</div>
                    </div>
                </div>
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5">Level Visibile:</div>
                        <div className="label label-warning-lite">Medium</div>
                        <div className="text-small-dark mg-r-5">70%</div>
                    </div>
                </div>
                <div className="wd-pct-30">
                    <div className="v-align">
                        <div className="text-small-muted mg-r-5"># Tests taken:</div>
                        <div className="text-small-dark mg-r-20">15</div>  
                    </div> 
                </div>        
            </div>
  </div>   
)}
export default EditSkill1;